import merge from 'merge';

module.exports = function(h, modules, classes, slots) {
    var filterId = 'VueTables__search_' + this.id;
    var ddpId = 'VueTables__dropdown-pagination_' + this.id;
    var perpageId = 'VueTables__limit_' + this.id;
    var perpageValues = require('vue-tables-2/compiled/modules/per-page-values').call(
        this,
        h,
    );

    // extended modules
    var rows = require('./modules/rows.jsx').call(this, h);
    var headings = require('./modules/headings.jsx').call(this, h);
    var actionButtons = require('./modules/action-buttons.jsx').call(this, h);
    var headerTitle = require('./modules/header-title.jsx').call(this, h);
    var columnsDropdownModule = require('./modules/columns-dropdown.jsx').call(
        this,
        h,
    );

    var genericFilter = this.hasGenericFilter ? (
        <div class="VueTables__search-field">
            <label for={filterId} class={classes.label}>
                {this.display('filter')}
            </label>
            {modules.normalFilter(classes, filterId)}
        </div>
    ) : (
        ''
    );

    var perpage =
        perpageValues.length > 1 ? (
            <div class="form-group form-inline VueTables__limit-field">
                <label class={classes.label} for={perpageId}>
                    {this.display('limit')}
                </label>
                {modules.perPage(perpageValues, classes.select, perpageId)}
            </div>
        ) : (
            ''
        );

    var dropdownPagination =
        this.opts.pagination && this.opts.pagination.dropdown ? (
            <div class="VueTables__pagination-wrapper">
                <div
                    class={`${classes.field} ${classes.inline} ${
                        classes.right
                    } VueTables__dropdown-pagination`}
                    v-show={this.totalPages > 1}
                >
                    <label for={ddpId}>{this.display('page')}</label>
                    {modules.dropdownPagination(classes.select, ddpId)}
                </div>
            </div>
        ) : (
            ''
        );

    var columnsDropdown = this.opts.columnsDropdown ? (
        <div class="VueTables__columns-dropdown-wrapper">
            {columnsDropdownModule(classes)}
        </div>
    ) : (
        ''
    );

    var footerHeadings = this.opts.footerHeadings ? (
        <tfoot>
            <tr>{modules.headings(classes.right)}</tr>
        </tfoot>
    ) : (
        ''
    );

    // checkbox actions button
    var checkboxActions = this.opts.checkbox ? (
        <vuetable2-header-action table-instance={this} />
    ) : (
        ''
    );

    // move to right if header text exists
    var filterPosition = headerTitle ? classes.right : classes.left;

    var tableTop =
        headerTitle ||
        genericFilter ||
        // perpage ||
        dropdownPagination ||
        columnsDropdown ||
        slots.beforeFilter ||
        slots.afterFilter ||
        slots.beforeLimit ||
        slots.afterLimit ? (
            <div
                class={'box-header VueTables__header'}
                v-show={!this.hasCheckboxSelected}
            >
                <div class="row">
                    <div class="col-xs-12">
                        {headerTitle}
                        {actionButtons.mobile}
                        {actionButtons.desktop}
                        {columnsDropdown}
                        <div
                            class={`${classes.field} ${
                                classes.inline
                            } ${filterPosition} VueTables__search`}
                        >
                            {slots.beforeFilter}
                            {genericFilter}
                            {slots.afterFilter}
                        </div>
                        <div
                            class={`${classes.field} ${
                                classes.inline
                            } VueTables__limit`}
                        >
                            {slots.beforeLimit}
                            {slots.afterLimit}
                        </div>
                        {dropdownPagination}
                    </div>
                </div>
            </div>
        ) : (
            ''
        );

    return (
        <div class={'VueTables VueTables--' + this.source}>
            {tableTop}
            {checkboxActions}
            {slots.beforeTable}
            <div class="">
                <div class="table-responsive">
                    <table
                        class={`VueTables__table ${
                            this.opts.skin ? this.opts.skin : classes.table
                        }`}
                    >
                        <thead>
                            <tr>{headings(classes.right)}</tr>
                            {slots.beforeFilters}
                            {modules.columnFilters(classes)}
                            {slots.afterFilters}
                        </thead>
                        {footerHeadings}
                        {slots.beforeBody}
                        <tbody>
                            {slots.prependBody}
                            {rows(classes)}
                            {slots.appendBody}
                        </tbody>
                        {slots.afterBody}
                    </table>
                </div>
                {slots.afterTable}
                <div class="dker">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            {perpage ? (
                                <div class="inline VueTables__per-page">
                                    {perpage}
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center clear">
                            {modules.pagination(
                                merge(classes.pagination, {
                                    wrapper: `${classes.contentCenter} m-t-1`,
                                    nav: classes.center,
                                    count: `${classes.center} ${
                                        classes.column
                                    }`,
                                }),
                            )}

                            {modules.dropdownPaginationCount()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/template.jsx